import { AppInventoryOption, type AppInventoryOptionType } from '@openx/types/targeting/appInventory.ts';
import { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent.ts';
import type { JSX } from 'react';
import { AppBundleId } from '../../InventoryAndContent/InventoryAndContentItems/AppBundleId.tsx';
import { AppInventoryItem } from '../../InventoryAndContent/InventoryAndContentItems/AppInventoryItem.tsx';

type InventoryContentWithoutContentOperator = Exclude<
  AppInventoryOptionType,
  typeof AppInventoryOption.APP_INVENTORY | typeof AppInventoryOption.APP_INVENTORY_INTER_DIMENSION_OPERATOR
>;

type InventoryAndContentT = {
  [key in InventoryContentWithoutContentOperator]: (
    isNotLastItem: boolean,
    showDimensionChipLine: boolean
  ) => JSX.Element | null;
};

export const getInventoryAndContentOptions = ({
  dispatchInventory,
  readonly,
  targetingParams,
  accountUid,
  appBundleIdDuplicateErrors,
  setInventoryListItems,
  inventoryListItems,
  switchState,
  getDisabledReasonMessage,
}): InventoryAndContentT => {
  const msg = getDisabledReasonMessage;
  return {
    [AppInventoryOption.APP_BUNDLE_ID]: (isNotLastItem, showDimensionChipLine) => (
      <AppBundleId
        readonly={readonly}
        targetingParams={targetingParams}
        dispatchInventory={dispatchInventory}
        key={AppInventoryOption.APP_BUNDLE_ID}
        isNotLastItem={isNotLastItem}
        switchState={switchState}
        accountUid={accountUid}
        appBundleIdDuplicateErrors={appBundleIdDuplicateErrors}
        setInventoryListItems={setInventoryListItems}
        inventoryListItems={inventoryListItems}
        showDimensionChipLine={showDimensionChipLine}
        disabledReasonMessage={msg?.(InventoryContentOption.APP_BUNDLE_ID)}
      />
    ),
    [AppInventoryOption.APP_GROUP]: (isNotLastItem, showDimensionChipLine) => (
      <AppInventoryItem
        dispatchInventory={dispatchInventory}
        readonly={readonly}
        targetingParams={targetingParams}
        key={AppInventoryOption.APP_GROUP}
        isNotLastItem={isNotLastItem}
        switchState={switchState}
        showDimensionChipLine={showDimensionChipLine}
        disabledReasonMessage={msg?.(InventoryContentOption.APP_GROUP)}
      />
    ),
  };
};
